import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

export const TodoIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      {/* Bulle de check menthe */}
      <circle cx="5.5" cy="6.5" r="2.75" fill="var(--equiply-icon-bg)" />
      <path
        d="M4.25 6.5l1 1 1.5-1.75"
        stroke="hsl(var(--background))" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Lignes de la liste */}
      <path
        d="M11 6.5h10M11 12h10M11 17.5h10"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
      {/* Puces vides bleues */}
      <circle cx="5.5" cy="12" r="2.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <circle cx="5.5" cy="17.5" r="2.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
    </svg>
  ),
);
TodoIcon.displayName = "TodoIcon";
